import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const LocalLogo = ({ filename, alt = '', loading = 'lazy', ...props }) => {
  const { locallogos } = useStaticQuery(
    graphql`
      query {
        locallogos: allFile(filter: { relativeDirectory: { eq: "hclogos" } }) {
          nodes {
            name
            childImageSharp {
              gatsbyImageData(
                # height: 300
                width: 300
                placeholder: TRACED_SVG
                formats: [WEBP, AVIF]
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    `,
  )

  const image = locallogos.nodes.find(node => node.name === filename)

  if (!image) {
    return null
  }

  return <GatsbyImage alt={alt} image={getImage(image)} loading={loading} />
}

export default LocalLogo
